import React from "react";

const Text = (props) => {
  let defaultClasses = "";

  if (props.type === "h1") {
    defaultClasses = "text-3xl font-bold block";
  }

  if (props.type === "h2") {
    defaultClasses = "text-2xl font-bold block";
  }

  if (props.type === "h3") {
    defaultClasses = "text-xl font-bold block";
  }

  return (
    <span {...props} className={`${defaultClasses} ${props.className}`}>
      {props.children}
    </span>
  );
};

export default Text;
